import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { breakpoint_xl } from "../mixins";

export const Container = styled.div`
  width: 100%;
  padding: 0 18px;
  @media (min-width: ${breakpoint_xl}) {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
  }
`;

export const TitleComponent = styled(Typography)`
  color: #000;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: -1.2px;
`;
export const DescriptionComponent = styled(Typography)`
  color: #000;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.9px;
  letter-spacing: -0.28px;
  opacity: 0.5;
`;
export const FullHeight = styled(Box)`
  min-height: 100vh;
`;

export const SpinningIcon = styled(Box)`
  animation: spin 2s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;

export const CountryIcons = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  button {
    cursor: pointer;
    border: none;
    outline: none;
    padding: 5px 8px;
    border-radius: 10px;
    background: #f0f0f0;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      transform: scale(1.1);
      background: rgb(170, 35, 59) !important;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    &.active {
      transform: scale(1.15);
      background: rgb(170, 35, 59) !important;
      color: white;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    }

    .activeImg {
      border: 1px solid white !important;
    }

    img {
      width: 45px;
      height: 30px;
      border-radius: 5px;
      box-shadow: 0px 0px 1px 0.5px gray;
      object-fit: cover;
    }
  }
`;
